import { OdnoklassnikiIcon } from '../../../../../assets/icons/socialNetwork/Odnoklassniki';
import { SocialNetworkButton } from './SocialNetworkButton';

import './style.scss';

interface OkButtonProps {
  children: string;
  url: string;
  onClick?(): void;
}

export const OkButton = ({ url, onClick, children }: OkButtonProps) => {
  return (
    <SocialNetworkButton
      icon={
        <OdnoklassnikiIcon
          width={36}
          height={36}
          fill="#fff"
          outlined={false}
        />
      }
      url={url}
      onClick={onClick}
      className="ok-button"
    >
      <span className="ok-button__text">{children}</span>
    </SocialNetworkButton>
  );
};
